/* tslint:disable */
/* eslint-disable */
/**
 * Walnut Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.155.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Configuration for specific settings
 * @export
 */
export const SettingTypeEnum = {
    Fixed: 'fixed',
    Default: 'default',
    OneOf: 'oneOf'
};
export function SettingTypeEnumFromJSON(json) {
    return SettingTypeEnumFromJSONTyped(json, false);
}
export function SettingTypeEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SettingTypeEnumToJSON(value) {
    return value;
}
